import { Component, Inject, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRAgents, RouteCMRAgentsEnum } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { SocketController } from '@shared/src/controllers/socket/socket.controller';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { RouteCMRAgentGoodsDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentGoodsDto';
import { AlertService, HString } from '@shared/src/public-api';

@Component({
    selector: 'shared-external-cmr-agent-goods',
    templateUrl: './shared.external.cmr.agent.goods.component.html',
    styleUrls: ['./shared.external.cmr.agent.goods.component.scss']
})
export class SharedExternalCMRAgentGoodsComponent implements OnInit {
   
    public useIonic: boolean = false;
    constructor(protected socketController: SocketController, public router: Router, protected activatedRoute: ActivatedRoute,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteCMRController: OpenRouteCMRController, public systemController: SystemController,
        @Inject('AlertService') public alertService: AlertService) {


        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();
    }

    ngOnInit(): void {
    }

    public __uuidQR: string;
    @Input()
    public set uuidQR(value: string) {
        if (this.__uuidQR === value)
            return;
        this.__uuidQR = value;
        this.loadData();
    }
    public get uuidQR(): string {
        return this.__uuidQR;
    }
    
    public __phaseUUID: string;
    @Input()
    public set phaseUUID(value: string) {
        if (this.__phaseUUID === value)
            return;
        this.__phaseUUID = value;
        this.loadData();
    }
    public get phaseUUID(): string {
        return this.__phaseUUID;
    }

    public __agent: RouteCMRAgents;
    @Input()
    public set agent(value: RouteCMRAgents) {
        if (this.__agent === value)
            return;
        this.__agent = value;
        this.loadData();
    }
    public get agent(): RouteCMRAgents {
        return this.__agent;
    }

    public value: RouteCMRAgentGoodsDto;
    loadData() {
        if(RouteCMRAgentsEnum.isValid(this.agent)){
            if (!HString.isNullOrNullString(this.phaseUUID)) {
                this.openRouteCMRController.getRouteCMRAgentGoodsByPhaseUUID(this.phaseUUID, this.agent).subscribe(data => { 
                    this.value = data;
                });
            } else if(!HString.isNullOrNullString(this.uuidQR)) {
                this.openRouteCMRController.getRouteCMRAgentGoodsByUUID(this.uuidQR, this.agent).subscribe(data => { 
                    this.value = data;
                });
            }
        }
    }

    public getCount():number{
        if(this.value == null)
            return 0;
        return this.value.countRouteParts;
    }

    
    public getResourceGoods(): string{
        if(this.value == null || this.value.countRouteParts == 0)
            return "";
        if(this.value.countRouteParts == 1)
            return 'SHARED.EXTERNAL.CMR.SHOWGOOD.CAPTION';
        return 'SHARED.EXTERNAL.CMR.SHOWGOODS.CAPTION';
    }
    
    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
